<template>
    <div class="login">
        <div class="login-form">
            <h1>Установите пин-код</h1>

            <p class="subtitle">Введите пин-код</p>

            <div class="pin-inputs">
                <a-input
                    v-for="(digit, index) in pin"
                    :key="index"
                    ref="pinInputs"
                    :value="pinDisplay[index]"
                    class="pin-digit"
                    type="text"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    autocomplete="off"
                    autocapitalize="none"
                    autocorrect="off"
                    spellcheck="false"
                    :maxlength="1"
                    @input="onInput(index, $event)"
                    @keydown="handleKeyDown(index, $event)"
                    @focus="onFocus(index)"
                    @paste.prevent="onPaste(index, $event, 'pin')"
                />
            </div>

            <p class="subtitle">Повторите пин-код</p>

            <div class="pin-inputs">
                <a-input
                    v-for="(digit, index) in confirmPin"
                    :key="index"
                    ref="confirmPinInputs"
                    :value="confirmPinDisplay[index]"
                    class="pin-digit"
                    type="text"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    autocomplete="off"
                    autocapitalize="none"
                    autocorrect="off"
                    spellcheck="false"
                    :maxlength="1"
                    @input="onConfirmInput(index, $event)"
                    @keydown="handleConfirmKeyDown(index, $event)"
                    @focus="onConfirmFocus(index)"
                    @paste.prevent="onPaste(index, $event, 'confirmPin')"
                />
            </div>

            <div v-if="errorMessage" class="error-message">
                {{ errorMessage }}
            </div>

            <a-button
                type="primary"
                class="login-btn"
                :disabled="!isPinsComplete || !doPinsMatch"
                @click="onSubmit"
            >
                Сохранить
            </a-button>
        </div>
        <app-version />
    </div>
</template>

<script>
import { RouterConfig } from '@/utils';
import AppVersion from '@/components/authorization/AppVersion.vue';

export default {
    name: 'AuthorizationPinUp',
    components: {
        AppVersion,
    },
    props: {
        resendCooldownSeconds: {
            type: Number,
            default: 30,
        },
    },
    data() {
        return {
            pin: ['', '', '', ''], // Реальные значения PIN
            pinDisplay: ['', '', '', ''], // Отображаемые значения (точки)
            confirmPin: ['', '', '', ''], // Реальные значения подтверждения PIN
            confirmPinDisplay: ['', '', '', ''], // Отображаемые значения подтверждения (точки)
            errorMessage: '',
            timerInterval: null,
        };
    },
    computed: {
        isPinsComplete() {
            return this.pin.every((digit) => digit !== '')
            && this.confirmPin.every((digit) => digit !== '');
        },
        doPinsMatch() {
            return this.pin.join('') === this.confirmPin.join('');
        },
    },
    mounted() {
        this.$nextTick(() => {
            if (this.$refs.pinInputs && this.$refs.pinInputs[0]) {
                this.$refs.pinInputs[0].focus();
            }
        });
    },
    watch: {
        isPinsComplete: {
            handler() {
                if (this.isPinsComplete) {
                    this.onSubmit();
                }
            },
        },
        // doPinsMatch: {
        //     handler() {
        //         if (this.doPinsMatch) {
        //             this.onSubmit();
        //         }
        //     },
        // },
    },
    methods: {
        onInput(index, event) {
            const { target: input } = event;
            const { value } = input;

            // Если введена цифра
            if (/^\d$/.test(value)) {
                // Сохраняем реальное значение
                this.pin[index] = value;
                // Отображаем точку
                this.pinDisplay[index] = '•';
                // Обновляем значение в поле ввода
                this.$nextTick(() => {
                    const inputElement = this.$refs.pinInputs[index]?.$el?.querySelector('input')
                        || this.$refs.pinInputs[index]?.$el;
                    if (inputElement) {
                        inputElement.value = '•';
                    }
                });

                if (index < 3) {
                    this.$nextTick(() => {
                        if (this.$refs.pinInputs[index + 1]) {
                            this.$refs.pinInputs[index + 1].focus();
                        }
                    });
                }

                if (index === 3) {
                    this.$nextTick(() => {
                        const confirmInputs = this.$refs.confirmPinInputs;
                        if (confirmInputs && confirmInputs[0]) {
                            confirmInputs[0].focus();
                        }
                    });
                }

                this.errorMessage = '';
            } else {
                // Если введен не цифра, очищаем поле
                this.pin[index] = '';
                this.pinDisplay[index] = '';
                input.value = '';
            }
        },
        handleKeyDown(index, event) {
            const { key } = event;

            if (key === 'Delete' || key === 'Backspace') {
                this.onDelete('pin', index);
                event.preventDefault();
            } else if (key === 'ArrowRight' && index < 3) {
                if (this.$refs.pinInputs[index + 1]) {
                    this.$refs.pinInputs[index + 1].focus();
                }
                event.preventDefault();
            } else if (key === 'ArrowLeft' && index > 0) {
                if (this.$refs.pinInputs[index - 1]) {
                    this.$refs.pinInputs[index - 1].focus();
                }
                event.preventDefault();
            }

            this.errorMessage = '';
        },
        onConfirmInput(index, event) {
            const { target: input } = event;
            const { value } = input;

            // Если введена цифра
            if (/^\d$/.test(value)) {
                // Сохраняем реальное значение
                this.confirmPin[index] = value;
                // Отображаем точку
                this.confirmPinDisplay[index] = '•';
                // Обновляем значение в поле ввода
                this.$nextTick(() => {
                    const inputElement = this.$refs.confirmPinInputs[index]?.$el?.querySelector('input')
                        || this.$refs.confirmPinInputs[index]?.$el;
                    if (inputElement) {
                        inputElement.value = '•';
                    }
                });

                if (index < 3) {
                    this.$nextTick(() => {
                        if (this.$refs.confirmPinInputs[index + 1]) {
                            this.$refs.confirmPinInputs[index + 1].focus();
                        }
                    });
                }

                this.errorMessage = '';
            } else {
                // Если введен не цифра, очищаем поле
                this.confirmPin[index] = '';
                this.confirmPinDisplay[index] = '';
                input.value = '';
            }
        },
        handleConfirmKeyDown(index, event) {
            const { key } = event;

            if (key === 'Delete' || key === 'Backspace') {
                this.onDelete('confirmPin', index);
                event.preventDefault();
            } else if (key === 'ArrowRight' && index < 3) {
                if (this.$refs.confirmPinInputs[index + 1]) {
                    this.$refs.confirmPinInputs[index + 1].focus();
                }
                event.preventDefault();
            } else if (key === 'ArrowLeft' && index > 0) {
                if (this.$refs.confirmPinInputs[index - 1]) {
                    this.$refs.confirmPinInputs[index - 1].focus();
                }
                event.preventDefault();
            }

            this.errorMessage = '';
        },
        onDelete(field, index) {
            const pinField = field === 'pin' ? this.pin : this.confirmPin;
            const pinDisplayField = field === 'pin' ? this.pinDisplay : this.confirmPinDisplay;
            const refs = field === 'pin' ? this.$refs.pinInputs : this.$refs.confirmPinInputs;

            if (pinField[index] === '') {
                if (index > 0) {
                    pinField[index - 1] = '';
                    pinDisplayField[index - 1] = '';
                    if (refs[index - 1]) {
                        refs[index - 1].focus();
                    }
                }
            } else {
                pinField[index] = '';
                pinDisplayField[index] = '';
            }
        },
        onFocus(index) {
            this.$nextTick(() => {
                if (this.$refs.pinInputs[index]) {
                    const input = this.$refs.pinInputs[index].$el?.querySelector('input')
                        || this.$refs.pinInputs[index].$el;
                    if (input) {
                        // Устанавливаем правильное отображаемое значение
                        input.value = this.pinDisplay[index] || '';
                        input.select();
                    }
                }
            });
        },
        onConfirmFocus(index) {
            this.$nextTick(() => {
                if (this.$refs.confirmPinInputs[index]) {
                    const input = this.$refs.confirmPinInputs[index].$el?.querySelector('input')
                        || this.$refs.confirmPinInputs[index].$el;
                    if (input) {
                        // Устанавливаем правильное отображаемое значение
                        input.value = this.confirmPinDisplay[index] || '';
                        input.select();
                    }
                }
            });
        },
        onPaste(index, event, field) {
            // Предотвращаем вставку из буфера обмена
            event.preventDefault();
            const pastedData = (event.clipboardData || window.clipboardData).getData('text');
            const digits = pastedData.replace(/\D/g, '').split('').slice(0, 4);

            const pinField = field === 'pin' ? this.pin : this.confirmPin;
            const pinDisplayField = field === 'pin' ? this.pinDisplay : this.confirmPinDisplay;
            const refs = field === 'pin' ? this.$refs.pinInputs : this.$refs.confirmPinInputs;

            digits.forEach((digit, i) => {
                if (index + i < 4 && /^\d$/.test(digit)) {
                    pinField[index + i] = digit;
                    pinDisplayField[index + i] = '•';
                }
            });
            // Обновляем отображаемые значения в полях
            this.$nextTick(() => {
                digits.forEach((digit, i) => {
                    if (index + i < 4 && /^\d$/.test(digit)) {
                        const inputElement = refs[index + i]?.$el?.querySelector('input')
                            || refs[index + i]?.$el;
                        if (inputElement) {
                            inputElement.value = '•';
                        }
                    }
                });
                // Фокус на последнее заполненное поле
                const lastIndex = Math.min(index + digits.length - 1, 3);
                if (refs[lastIndex]) {
                    refs[lastIndex].focus();
                }
            });
        },
        async onSubmit() {
            if (!this.isPinsComplete) {
                this.errorMessage = 'Введите оба пин-кода';
                return;
            }

            if (!this.doPinsMatch) {
                this.errorMessage = 'Пин-коды не совпадают';
                return;
            }

            const { deviceId, staffId } = localStorage;
            const pinCode = this.pin.join('');
            const pinCodeConfirm = this.confirmPin.join('');

            if (!/^\d{4}$/.test(pinCode)) {
                this.errorMessage = 'Пин-код должен состоять из 4 цифр';
                return;
            }

            try {
                const requestBody = {
                    pin: pinCode,
                    confirmPin: pinCodeConfirm,
                    deviceId,
                    userId: staffId,
                };

                // Добавляем isForgotReset, если пользователь пришел из процедуры "Забыли пароль?"
                if (this.$route.query.isForgotReset === 'true') {
                    requestBody.isForgotReset = true;
                }

                const response = await this.$http.post('/v2/auth/pin/setup', requestBody);

                const { user = {} } = response.data;

                if (Object.keys(user).length) {
                    const {
                        name,
                        previewFileId,
                        clinics,
                        id,
                        chatUserId,
                        chatUserToken,
                        timePasswordExpire,
                    } = user || {};

                    localStorage.username = name;
                    localStorage.previewFileId = previewFileId;
                    localStorage.clinics = clinics;
                    localStorage.staffId = id;
                    localStorage.chatUserId = chatUserId;
                    localStorage.chatUserToken = chatUserToken;
                    localStorage.timePasswordExpire = timePasswordExpire;
                }

                localStorage.LoggedIn = true;
                // this.$router.push({ name: 'main' });
                if (user?.changePassword) {
                    this.$router.push({ name: RouterConfig.changePassword.name });
                } else {
                    this.$router.push({ name: 'main' });
                }
            } catch (error) {
                // Очищаем пин-коды при ошибке
                this.pin = ['', '', '', ''];
                this.pinDisplay = ['', '', '', ''];
                this.confirmPin = ['', '', '', ''];
                this.confirmPinDisplay = ['', '', '', ''];
                this.$nextTick(() => {
                    // Очищаем отображаемые значения в полях
                    this.$refs.pinInputs?.forEach((pinInput) => {
                        const input = pinInput.$el?.querySelector('input') || pinInput.$el;
                        if (input) {
                            input.value = '';
                        }
                    });
                    this.$refs.confirmPinInputs?.forEach((pinInput) => {
                        const input = pinInput.$el?.querySelector('input') || pinInput.$el;
                        if (input) {
                            input.value = '';
                        }
                    });
                    if (this.$refs.pinInputs[0]) {
                        this.$refs.pinInputs[0].focus();
                    }
                });

                if (error?.response?.data?.error) {
                    this.errorMessage = error.response.data.error;
                } else if (error?.response?.data?.msg) {
                    this.errorMessage = error.response.data.msg;
                }
            }
        },
    },
    beforeUnmount() {
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }
    },
};
</script>

<style lang="scss" scoped>
.login {
    background: url("/images/login-wall.jpg") center center / cover no-repeat rgb(255, 255, 255);
    height: 100%;
    display: flex;
}

.login-form {
    position: relative;
    margin: auto;
    max-width: 460px;
    min-height: 330px;
    width: 100%;
    border-radius: 8px;
    border: 1px solid #e8e8e8;
    padding: 26px;
    background-color: transparent;
    z-index: 1;
    overflow: hidden;

    display: flex;
    flex-direction: column;
    align-items: center;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        background-color: #fff;
        opacity: 0.8;
        z-index: -1;
    }

    h1 {
        font-size: 26px;
        font-weight: bold;
        margin-bottom: 8px;
        text-align: center;
    }

    .subtitle {
        color: #666;
        font-size: 14px;
        margin-bottom: 8px;
        text-align: center;
        padding: 0 30px;
    }

    .pin-inputs {
        display: flex;
        justify-content: center;
        gap: 8px;
        margin-bottom: 14px;

        &:last-of-type {
            margin-bottom: 18px;
        }

        .pin-digit {
            width: 50px;
            height: 50px;
            text-align: center;
            font-size: 20px;
            border-radius: 8px;
            border: 1px solid #d9d9d9;

            &:focus {
                border-color: #83b274;
                box-shadow: 0 0 0 2px rgb(131, 178, 116, 0.2);
            }
        }
    }

    .error-message {
        color: #ff4d4f;
        font-size: 12px;
        margin-block: 15px;
        text-align: left;
        max-width: 100%;
        word-break: break-word;
        white-space: pre-wrap;
        line-height: 1.4;
        padding: 8px 10px;
        background: #fff5f5;
        border: 1px solid #ffccc7;
        border-radius: 4px;
        overflow-x: hidden;
    }

    .timer {
        font-size: 14px;
        margin-bottom: 15px;
        text-align: center;
        color: #666;
    }

    .additional-buttons {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-top: 15px;

        .ant-btn {
            width: 100%;
            text-align: center;
        }
    }

    .login-btn {
        min-width: 110px;
        height: auto;
        font-size: 14px;
        margin-top: auto;

        padding: 7px 20px;
        background-color: #8dc07c;
        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
        box-shadow: 0px 0px 4px rgba(46, 75, 37, 0.4);
        border: none;
        color: #fff;

        &:disabled,
        &[disabled] {
            pointer-events: none;
            opacity: 0.5;
        }

        &:hover {
            background-color: #74b85d;
        }
    }

    .back-button {
        position: absolute;
        top: 10px;
        left: 10px;
        padding: 0;
        font-size: 16px;
    }
}
</style>
